/* eslint-disable */
import React from 'react';
import { OrbitControls, Environment, ContactShadows } from '@react-three/drei';
import ModelViewer from './ModelViewer';

export default function Scene({ mouse, triggerRef }) {
  return (
    <>
      <ambientLight intensity={1.8} />
      <hemisphereLight intensity={1.5} groundColor="#ffffff" />

      <directionalLight position={[4, 6, 5]} intensity={2.8} />
      <directionalLight position={[-4, 3, 3]} intensity={1.4} />
      <pointLight position={[0, 2, 3]} intensity={1.2} color="#ffffff" />

      <Environment preset="city" />

      <ModelViewer mouse={mouse} triggerRef={triggerRef} />

      <ContactShadows
        position={[0, -1.25, 0]}
        opacity={0.24}
        scale={8}
        blur={2.5}
        far={4}
      />

      <OrbitControls
        enableZoom={false}
        enablePan={false}
        enableRotate={false}
      />
    </>
  );
}